module.exports = __webpack_public_path__ + "img/djnodata.9f63fccf.png";